<template>
  <div>
    <v-card flat>
      <v-card-title>
        <v-row>
          <v-flex class="ml-6 mr-6" s3>
            <v-row>
              <v-switch label="Current" v-model="active"/>
              <v-switch class="ml-8" label="Future" v-model="future"/>
              <v-switch class="ml-8" label="Cancelled" v-model="cancelled"/>
              <v-switch  class="ml-8" label="Archived" v-model="archived"/>
              <v-switch  class="ml-8" label="Out of Scope" v-model="outOfScope"/>
            </v-row>
          </v-flex>
          <v-flex class="ml-6 mr-6" s3>
            <v-row>
              <v-menu
                v-model="menu"
                :close-on-content-click="true"
                :nudge-right="20"
                transition="scale-transition"
                offset-y
                min-width="0px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      class="ml-8"
                      clearable
                      label="Created Start Date"
                      readonly
                      v-bind="attrs"
                      v-model="startDate"
                      v-on="on"
                      style="max-width: 200px"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="startDate" no-title @input="menu = false"></v-date-picker>
              </v-menu>
              <v-menu
                  v-model="menu2"
                  :close-on-content-click="true"
                  :nudge-right="20"
                  transition="scale-transition"
                  offset-y
                  min-width="0px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      class="ml-8"
                      clearable
                      label="Created End Date"
                      readonly
                      v-bind="attrs"
                      v-model="endDate"
                      v-on="on"
                      style="max-width: 200px"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="endDate" no-title @input="menu2 = false"></v-date-picker>
              </v-menu>
              <v-text-field
                  class="ml-8"
                  append-icon="mdi-magnify"
                  clearable
                  v-model="search"
                  label="Search Requests"
              />
              <v-btn 
                color="gray" 
                @click="clearFilters"
                :disabled="!hasActiveFilters"
                :loading="clearingFilters"
                class="ml-8 mt-2"
                aria-label="Clear all filters"
              >
                <v-icon left>mdi-filter-remove</v-icon>
                Clear Filters
              </v-btn>
            </v-row>
          </v-flex>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :loading="tableLoading"
          :server-items-length="serverItemsLength"
          :options.sync="options"
          :footer-props="{'items-per-page-options': [10, 25, 50]}"
          scrollable
          disable-sort
          class="elevation-2 mt-n3 mb-2 pb-0"
          loading-text="Loading... Please wait"
          :headers="requestTableHeaders"
          @click:row="rowClick"
          :items="data"
          no-data-text="No Service Requests to Display">

          <template v-slot:item.created="{ item }">
            {{mixin_UTCToPretty(item.created)}}
          </template>

          <template v-slot:item.last_updated="{ item }">
            {{mixin_UTCToPretty(item.last_updated)}}
          </template>

          <template v-slot:item.status="{ item }">
            <span :class="item.priority ? 'red--text' : item.simple_status === 'Active' ? '' : 'grey--text'">{{ item.status }}</span>
          </template>

          <template v-slot:item.to_amount ="{ item }">
            <span v-if="item.from_asset" :style="{color: assetColor(item.from_asset)}">
              -{{ item.from_amount }}
            </span>
            <br v-if="item.from_asset && item.to_asset"/>
            <span v-if="item.to_amount" :style="{color: assetColor(item.to_asset)}">
              {{ item.to_amount }}
            </span>
          </template>>

          <template v-slot:item.to_asset ="{ item }">
            <span :style="{color: assetColor(item.from_asset)}">
              {{ assetIDToName(Number(item.from_asset)) }}
            </span>
            <br v-if="item.from_asset && item.to_asset"/>
            <span :style="{color: assetColor(item.to_asset)}">
              {{ assetIDToName(Number(item.to_asset)) }}
            </span>
          </template>

          <template v-slot:item.directed_to ="{ item }">
            {{ item.simple_status === 'Active' ? item.directed_to : '' }}
          </template>

          <template v-slot:item.follow_up ="{ item }">
            <v-tooltip bottom v-if="item.follow_up">
              <template #activator="{ on }">
                <span v-on="on"> {{item.follow_up ? 'Y' : 'N'}} </span>
              </template>
              <span >{{ item.follow_up_note }} <br/> {{ mixin_UTCToPretty(item.timestamp)}}</span>
            </v-tooltip>
            <span v-else>{{item.follow_up ? 'Y' : 'N'}}</span>
          </template>

          <template v-slot:item.new_tab ="{ }">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn v-on="on" icon>
                  <v-icon @click="newTab = true">mdi-tab-plus</v-icon>
                </v-btn>
              </template>
              <span>Open Task in a New Tab</span>
            </v-tooltip>
          </template>

        </v-data-table>

      </v-card-text>
    </v-card>
    <error-dialog ref="errorDialog" />
  </div>
</template>

<script>
import ErrorDialog from "../components/ErrorDialog";

export default {
  name: 'Tasks',
  components: {ErrorDialog},
  data() {
    return {
      search: '',
      menu: false,
      menu2: false,
      data: [],
      options: {},
      serverItemsLength: null,
      tableLoading: false,
      active: true,
      archived: false,
      cancelled: false,
      outOfScope: false,
      startDate: null,
      endDate: null,
      future: false,
      newTab: false,
      clearingFilters: false,
      isInitializing: false, // Flag to prevent watchers during URL initialization
      debounceTimeout: null, // Timeout for debouncing API calls
      requestTableHeaders: [
        {value: 'created', text: 'Created'},
        {value: 'last_updated',  text: 'Last Updated'},
        {value: 'day_due', text: 'Actionable On'},
        {value: 'type',  text: 'Type'},
        {value: 'status',  text: 'Status'},
        {value: 'name',text: 'Name'},
        {value: 'username',   text: 'Username'},
        {value: 'to_amount', text: 'Amounts', align: 'end'},
        {value: 'to_asset', text: 'Assets', align: 'start'},
        {value: 'order_id', text: 'Order #'},
        {value: 'directed_to', text: 'Directed Towards'},
        {value: 'follow_up',   text: 'Follow Up?'},
        {value: 'new_tab',   text: '', align: 'end'}
      ],
    }
  },
  computed: {
    hasActiveFilters() {
      return this.active !== true || 
             this.archived !== false || 
             this.cancelled !== false || 
             this.future !== false || 
             this.outOfScope !== false || 
             this.startDate !== null || 
             this.endDate !== null || 
             this.search !== '';
    },
    // Computed property that combines all filter values for efficient watching
    filterState() {
      return {
        active: this.active,
        archived: this.archived,
        cancelled: this.cancelled,
        future: this.future,
        outOfScope: this.outOfScope,
        startDate: this.startDate,
        endDate: this.endDate,
        search: this.search
      };
    }
  },
  watch: {
    // Watch all filter changes with a single watcher
    filterState: {
      handler(newVal, oldVal) {
        if (!this.isInitializing) {
          // Check if only search changed
          const searchChanged = oldVal && newVal.search !== oldVal.search;
          const searchCleared = searchChanged && newVal.search === '';
          
          // Reset to page 1 if search changed
          if (searchChanged && this.options.page !== 1) {
            this.options.page = 1;
            return; // Let the options watcher handle the API call
          }
          
          // Use longer debounce (500ms) for typing, shorter (300ms) for clearing or other filters
          const delay = searchChanged && !searchCleared ? 500 : 300;
          this.debouncedGetServiceRequests(delay);
        }
      },
      deep: true
    },
    // Watch pagination/sorting options separately
    options: {
      handler() {
        if (!this.isInitializing) {
          this.debouncedGetServiceRequests(300);
        }
      },
      deep: true
    }
  },
  mounted() {
    localStorage.title = 'Tasks';
    this.initializeFromURL();
  },

  beforeDestroy() {
    // Clean up any pending debounce timeouts
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
  },

  methods: {
    // Initialize component state from URL query parameters
    initializeFromURL() {
      try {
        // Set flag to prevent watchers from firing during initialization
        this.isInitializing = true;
        
        const query = this.$route.query;
        
        // Set filter values from URL parameters with validation
        this.active = query.active !== undefined ? query.active === 'true' : true;
        this.archived = query.archived === 'true';
        this.cancelled = query.cancelled === 'true';
        this.future = query.future === 'true';
        this.outOfScope = query.outOfScope === 'true';
        
        // Validate and set dates
        this.startDate = this.validateDate(query.startDate) ? query.startDate : null;
        this.endDate = this.validateDate(query.endDate) ? query.endDate : null;
        
        // Validate and set search (truncate if too long)
        this.search = query.search ? String(query.search).substring(0, 60) : '';
        
        // Set pagination from URL with validation
        if (query.page && !isNaN(parseInt(query.page))) {
          this.options.page = Math.max(1, parseInt(query.page));
        }
        if (query.itemsPerPage && !isNaN(parseInt(query.itemsPerPage))) {
          const validItemsPerPage = [10, 25, 50].includes(parseInt(query.itemsPerPage)) 
            ? parseInt(query.itemsPerPage) 
            : 10;
          this.options.itemsPerPage = validItemsPerPage;
        }
        
        // Re-enable watchers and load data with URL parameters
        // Use $nextTick to ensure all watchers have processed before making the API call
        this.isInitializing = false;
        this.$nextTick(() => {
          // If no watchers fired (e.g., all default values), manually trigger the call
          this.debouncedGetServiceRequests();
        });
      } catch (error) {
        console.warn('Failed to parse URL parameters, using defaults:', error);
        // Fallback to default values if URL parsing fails
        this.isInitializing = true;
        this.resetToDefaults();
        this.isInitializing = false;
        this.$nextTick(() => {
          this.debouncedGetServiceRequests();
        });
      }
    },

    // Validate date format (YYYY-MM-DD)
    validateDate(dateString) {
      if (!dateString) return false;
      const date = new Date(dateString);
      return date instanceof Date && !isNaN(date) && dateString.match(/^\d{4}-\d{2}-\d{2}$/);
    },

    // Reset all filters to default values
    resetToDefaults() {
      this.active = true;
      this.archived = false;
      this.cancelled = false;
      this.future = false;
      this.outOfScope = false;
      this.startDate = null;
      this.endDate = null;
      this.search = '';
      this.options.page = 1;
      this.options.itemsPerPage = 10;
    },

    // Update URL query parameters with current filter state
    updateURL() {
      const query = {
        active: this.active,
        archived: this.archived,
        cancelled: this.cancelled,
        future: this.future,
        outOfScope: this.outOfScope,
        startDate: this.startDate,
        endDate: this.endDate,
        search: this.search,
        page: this.options.page || 1,
        itemsPerPage: this.options.itemsPerPage || 10
      };

      // Remove null/empty values to keep URL clean
      Object.keys(query).forEach(key => {
        if (query[key] === null || query[key] === '' || 
            (key === 'active' && query[key] === true) ||
            (['archived', 'cancelled', 'future', 'outOfScope'].includes(key) && query[key] === false)) {
          delete query[key];
        }
      });

      // Update URL without triggering navigation
      this.$router.replace({ 
        path: this.$route.path, 
        query: query 
      }).catch(() => {}); // Ignore navigation errors
    },


    // Clear all filters and reset to defaults
    async clearFilters() {
      this.clearingFilters = true;
      
      try {
        this.resetToDefaults();
        this.updateURL();
      } catch (error) {
        console.error('Error clearing filters:', error);
        this.$refs.errorDialog.showError({
          errorMessage: 'Error clearing filters',
          forDevelopers: error.message
        });
      } finally {
        this.clearingFilters = false;
      }
    },

    rowClick: function (item) {
      if (this.newTab) window.open('/tasks/' + item.uuid, '_blank');
      else this.$router.push({path: '/tasks/' + item.uuid});
      this.newTab = false;
    },

    // Debounced wrapper for getServiceRequests to prevent multiple simultaneous calls
    debouncedGetServiceRequests(delay = 300) {
      // Clear any pending request
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      
      // Wait for specified delay before making the API call to batch rapid changes
      this.debounceTimeout = setTimeout(() => {
        this.getServiceRequests();
      }, delay);
    },

    async getServiceRequests() {
      const url = '/admin/service/requests'
      this.tableLoading = true
      const body = {
        offset: (this.options.itemsPerPage * this.options.page) - this.options.itemsPerPage,
        length: this.options.itemsPerPage,
        active: this.active,
        archived: this.archived,
        search: this.search,
        cancelled: this.cancelled,
        future: this.future,
        outOfScope: this.outOfScope,
        startDate: this.startDate,
        endDate: this.endDate
      }
      
      try {
        const {data} = await this.$axios.post(url, body);
        this.serverItemsLength = data.record_count
        this.data = data.data
        
        // Update URL only after successful API call
        this.updateURL();
      } catch ({response}) {
        this.$refs.errorDialog.showError({
          errorMessage: response.data.message,
          forDevelopers: response.data.validationErrors
        });
      } finally {
        this.tableLoading = false
      }
    }
  },
}
</script>

<style scoped>
</style>